import { render, staticRenderFns } from "./Bebox.vue?vue&type=template&id=3885b1a8&"
import script from "./Bebox.vue?vue&type=script&lang=js&"
export * from "./Bebox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports